import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardKepalaSkbTimKinerja } from 'app/KinerjaKepalaSKBPage/components/PageGuardKepalaSkbTimKinerja'
import { Homepage } from 'app/KinerjaKepalaSKBPage/pages/tim-kinerja/Homepage'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<{}>> => {
    const isEnabled = toggle?.['kinerja-spnf-enabled'] || false
    if (!isEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }
  },
})

export default function Page() {
  return (
    <PageGuardKepalaSkbTimKinerja>
      <Homepage />
    </PageGuardKepalaSkbTimKinerja>
  )
}

Page.Layout = KinerjaLayout
